module.exports = __webpack_public_path__ + "static/media/wantaowei.f7e454b3.jpg";